// extracted by mini-css-extract-plugin
export var copyright = "styles-module--copyright--53613";
export var copyright_container = "styles-module--copyright_container--cb5ce";
export var information = "styles-module--information--3d980";
export var producer_login = "styles-module--producer_login--7266a";
export var social_container = "styles-module--social_container--c4a56";